export const PASSWORD_CONST = 'password';

export const AIA_UNIT = '_aia__';
